<mat-toolbar class="content-header">
  <div class="page-title">
    <mat-icon>person_add</mat-icon>
    <h1 class="page-title">{{'stream.invite.via_mail' | translate}}</h1>
  </div>

  <div class="actions">
    <app-search-bar (searchText)="search($event)" [width]="isMobile ? 100 : 200"></app-search-bar>
    <app-date-picker
      [startDate]="startDate"
      [min]="now"
      [max]="maxDate"
      [hideTime]="false"
      (dateChanged)="onDatePickerChanged($event)"
      (closed)="onDatePickerClosed()"
    >
    </app-date-picker>
    <lib-button
      *ngIf="event"
      icon="share"
      color="none"
      textColor="secondary"
      tooltip=""
      (click)="copyLink()">
    </lib-button>
  </div>
  <div class="close">
    <lib-button icon="close" color="none" class="action" (click)="close()"></lib-button>
  </div>
</mat-toolbar>

<ng-container>
  <div class="table-container">
    <table mat-table [dataSource]="usersData" matSort>
      <!-- USER COLUMN -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="account_circle" aria-hidden="true"></mat-icon>
            User
          </div>
        </th>

        <td mat-cell *matCellDef="let row">
          <div class="user-info">
            <p class="email">{{row.email}}</p>
            <p class="name">{{row.firstName}} {{row.lastName}}</p>
            <p class="company">{{row.company}}</p>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="person" aria-hidden="true"></mat-icon>
            Role
          </div>
        </th>

        <td mat-cell *matCellDef="let row">
          <mat-button-toggle-group
            [(ngModel)]="row.hseRole"
            [hideSingleSelectionIndicator]="true"
            [disabled]="row.invited"
          >
              <mat-button-toggle value="publisher" [disabled]="isPublisherTaken()">
                <mat-icon>videocam</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="viewer">
                <mat-icon>visibility</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
        </td>
      </ng-container>


      <!-- ACTION COLUMN (Invite Button) -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="invite-header">
          <div class="header-content actions-header">
            <mat-icon fontIcon="send" aria-hidden="true"></mat-icon>
            {{ 'form.action'| translate }}
          </div>
        </th>

        <td mat-cell *matCellDef="let row" class="action-cell invite-cell">
          <lib-button
            icon="person_add"
            color="primary"
            text="{{'form.invite' | translate}}"
            [disabled]="row.invited"
            (click)="invite(row)">
          </lib-button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="usersColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: usersColumns;"></tr>

      <!-- @if (!loading && !users.length) { -->
      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="usersColumns.length">
          <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
          </lib-no-data>
        </td>
      </tr>
      <!-- } -->

    </table>

    <div *ngIf="loading" class="table-overlay">
      <app-spinner></app-spinner>
    </div>

    <mat-paginator #userPaginator [length]="usersCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
      class="paginator" (page)="handlePageEvent($event)">
    </mat-paginator>
  </div>
</ng-container>
